<template>
  <li class="filter" :class="{'active': isActive}" @click="changeStatus"><i class="icon-plus"></i><span>{{ filterElement.name }}</span>
  </li>
</template>
<script>
export default {
  name: 'filterElement',
  props: {
    filterElement: {},
    isActive: false
  },
  data() {
    return {
      active: false
    }
  },
  methods: {
    changeStatus() {
      this.$emit('statusChange', this.filterElement.id);
    }
  }
}
</script>
